
import * as L from "leaflet";
import "leaflet.markercluster";
import "../leaflet/leaflet-unwired";
import axios from "axios";
import { stringify } from "qs";
import { bind_swiper } from "../swiper";


const {site, language_switch, is_vm } = window.tg;
/*
---------------------------------
LocationIQ Map
---------------------------------
*/
const key = is_vm ? 'pk.6537bbbbca6841d84b5aab72c79fc55b' : 'pk.65bfcd4f74a29a6fd2c0e62cc587c59d';

var leafletMap = {
    _key: key,
  _map: null,
  _cluster: null,

  _miniLoadedAtZoom: 0,
  _miniLoadedAtLat: 0,
  _miniLoadedAtLng: 0,

  _extensionForIcons: 1.3,
  _movingSensitivity: 3,
    // Whitelabel this below
  _site: site,
  _identifier: 'js-map-canvas',
  _options: { showCenterMarker: true },

  initialize: function (coords, options) {
    var that = this;
    this._originalCenter = coords;
    this._options = Object.assign({}, this._options, options || {});

    if (typeof this._options.identifier !== 'undefined' && this._options.identifier !== '') {
        this._identifier = this._options.identifier;
    }

    this._leafletMainIcon = L.icon({
        iconUrl: '/cdn/images/stays/integrations/leaflet/' + site + '/map-marker-main.png',
        className: 'map-marker-icon',
        iconSize: [32, 32], // size of the icon
        iconAnchor: [16, 32] // point of the icon which will correspond to marker's location
    });

    this._leafletMiniIcon = L.icon({
        iconUrl: '/cdn/images/stays/integrations/leaflet/' + site + '/map-marker-small.png',
        className: 'map-marker-icon',
        iconSize: [16, 14], // size of the icon
        iconAnchor: [8, 0] // point of the icon which will correspond to marker's location
    });

    this._leafletMiniUnavailableIcon = L.icon({
        iconUrl: '/cdn/images/stays/integrations/leaflet/' + site + '/map-marker-unavailable.png',
        className: 'map-marker-icon-unavailable',
        iconSize: [16, 14], // size of the icon
        iconAnchor: [8, 0] // point of the icon which will correspond to marker's location
    });


    // Add layers that we need to the map
    var streets = L.tileLayer.Unwired({ key: this._key, scheme: "streets" });

    // Remove the map in case reinitialised
    if (this._map) {
        this._map.remove();
    }

    // Initialize the map
    this._map = L.map(this._identifier, {
      center: coords,
      zoom: 14,
      scrollWheelZoom: false,
      preferCanvas: true,
      layers: [streets], // Show 'streets' by default,
      dragging: true
    });

    if (this._options.fitBounds) {
        this._map.fitBounds([
                [this._options.latMin, this._options.longMin],
                [this._options.latMax, this._options.longMax]
        ])

    }

    // TODO: Debounce between zoomend / moveend
    this._map.on('zoomend', function () {
      var newZoomLevel = that._map.getZoom();
      var zoomDifference = Math.abs(that._miniLoadedAtZoom - newZoomLevel);
      if (zoomDifference > 1) {
        that.addMiniMarkers();
      }
    });

    this._map.on('moveend', function () {
      var center = that._map.getCenter();
      var lat = center.lat;
      var lng = center.lng;

      var bounds = that._map.getBounds();
      var nsSpan = bounds.getNorth() - bounds.getSouth();



      var latchange = parseFloat(lat) - parseFloat(that._miniLoadedAtLat);


      var longchange = parseFloat(lng) - parseFloat(that._miniLoadedAtLng);
      var difference = Math.sqrt(latchange * latchange + longchange * longchange);

      if (difference > (nsSpan / that._movingSensitivity)) {
        that.addMiniMarkers();
      }
    });

    // Add the 'scale' control

    L.control.scale({ position: 'bottomright' }).addTo(this._map);

    // Add the default marker
    if (this._options.showCenterMarker) {

      var marker = L.marker(coords, { icon: this._leafletMainIcon, zIndexOffset: 1000 }).addTo(this._map);
    }
    // Add the cluster group plugin

    this._cluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      disableClusteringAtZoom: 14,
      maxClusterRadius: 40
    })
    this._map.addLayer(this._cluster);

    this._cluster.on('click', function (e) {
        axios({
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            method: 'post',
            url: "/backend/accommodation/generate_map_snippet",
            data: stringify({ id: e.layer.eid, alloc: e.layer.alloc, avl: e.layer.avl }),
        })
        .then (function (response) {
            const data = response.data;

            // Timeout for user to perceive action as loading
            if (data.success === true && data.data.map_snippet_html) {
                const html = data.data.map_snippet_html;
                that._map.openPopup(html, e.latlng, { closeButton: false, autoPanPaddingTopLeft: [25,0], autoPanPaddingBottomRight: [25,0]});

                document.addEventListener('click', function(event) {
                    const el = /** @type {HTMLTextAreaElement} */ (event.target);

                    if (el != undefined && el.classList.contains('js-close-popup')) {
                        that._map.closePopup();
                    }
                },false)

                bind_swiper('.js-swiper-map');
            } else {
                //TODO: Something went wrong
            }
        })
    })



    // Add the mini markers
    this.addMiniMarkers()
  },

  reset: function () {
    this._map.setView(this._originalCenter, 14);
  },

  clearMiniMarkers: function () {
    this._cluster.clearLayers()
  },

  addMiniMarkers: function () {
    var that = this;
    var lat = this._map.getCenter().lat;
    var lng = this._map.getCenter().lng;
    var zoom = this._map.getZoom();
    var rad = this._map.distance(this._map.getBounds().getNorthEast(), this._map.getBounds().getSouthWest()) / 2000;


    if (this._miniRequest) {
      this._miniRequest.abort()
      this._miniRequest = null
    }


    this._miniRequest = $.post("/ajax/map/get_simple_map_marker_points.php", { lat: lat, lng: lng, rad: rad * this._extensionForIcons }, function (data) {
      data = JSON.parse(data);
      that.clearMiniMarkers();
      that._miniLoadedAtZoom = zoom;
      that._miniLoadedAtLat = lat;
      that._miniLoadedAtLng = lng;

      that.createMiniMarkers(data.data);
    });
  },

  createMiniMarkers: function (data) {

    var markers = [];
    for (var i = 0; i < data.length; i++) {

        let latitude = data[i].lat ? data[i].lat : data[i].latitude
        let longitude = data[i].lng ? data[i].lng : data[i].longitude
        let availability = data[i].avl ? data[i].avl : data[i].availability
        let allocated = data[i].alloc ? data[i].alloc : data[i].allocated
        let establishment_id = data[i].eid ? data[i].eid : data[i].establishment_id

      var marker = L.marker([latitude, longitude], { icon: availability === undefined ? this._leafletMiniIcon : (availability != -1 && availability != -2) ? this._leafletMiniIcon : this._leafletMiniUnavailableIcon });
      if (availability !== undefined) {
        marker.avl = availability
        marker.alloc = allocated
      }

      marker.eid = establishment_id;
      markers.push(marker);
    }
    this._cluster.addLayers(markers);
  },
}

window.tg.leafletMap = leafletMap;
